<template>
  <bsp-dialog :title="optParams.title" :dialogVisible.sync="visible" @closeButton="closeDialog" width="85%">
    <template #body>
      <div class="iframIndex" id="iframIndex">
        <iframe ref="dialogIframe" id="dialogIframe" :src="srcUrl" width="100%" height="100%" style="min-height: 500px;"></iframe>
      </div>
    </template>
  </bsp-dialog>
</template>
<script>
import BspDialog from "@/components/bsp/bsp-dialog/bsp-dialog";
import { encrypt, addClass, removeClass } from "@/util/util";
import { base64Encode } from "@/util/endecode.js";
import { mapGetters } from 'vuex';
export default {
  name: "optDialog",
  components: {
    BspDialog
  },
  props:{
    optParams: {
      type: Object,
      default: function (){
        return {
        };
      },
    },
  },
  computed: {
    ...mapGetters([
      'accessToken',
      'dicts'
    ]),
    codeMap() {
      return this.dicts.codeMap;
    }
  },
  watch: {
  },
  created() {
    this.preUrl = process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL;
    this.themeType = this.$store.getters.themeType;
    var lang = localStorage.getItem("lang");
    lang = lang || 'zh' ;
    if (!this.themeType) {
      this.themeType = "";
    }
    this.parmStr = "lang=" + base64Encode(lang) + "&accessToken=" + this.$store.getters.accessToken + "&aacode=invoice";
  },
  data () {
    return {
      labelName : "",
      loading: false,
      visible: false,
      preUrl: process.env.VUE_APP_ACCOUNT_CLOUD_BASE_URL,
      routerPath: this.fpath ? this.fpath : this.$route.path,
      routerParms: this.fpath ? '' : this.$route.query,
      parmStr: "",
      themeType: "",
      srcUrl:"",
      title:"",
    }
  },
  methods: {
    init() {
      this.createIframe();
    },
    createIframe() {
      // 为了解决浏览器回退的路由问题
      // 如果当前存在iframe,销毁它
      var div = document.getElementById("iframIndex");
      console.log("div:" + div);

      // if (!this.fpath) {
      //   if (div.firstChild) div.removeChild(div.firstChild);
      // }
      // 创建iframe
      // var iframe = document.createElement("iframe");
      // iframe.id = "main";
      // iframe.ref = this.preUrl;
      // newUrl=basePath+"/baseInfo/bankListIndex.action?CID="+payeeId.base64Encode()+"&from="+"cost".base64Encode();
      //var url = this.preUrl + "/baseInfo/bankListIndex.action?CID=" + base64Encode("40284ba596a9a5db0196a9dfe49a003d") + "&" + this.parmStr;
      var url = this.preUrl + this.optParams.url + "&" + this.parmStr;

      console.log("iframeUrl:" + url)
      this.$set(this,"srcUrl", url);
      //this.$set(this,"srcUrl", this.optParams.url);

      //window.open(url, '_blank')
      //addClass(document.getElementsByTagName("body")[0], "pubIndex");
      //routePath += (routePath.indexOf("?") < 0 ? "?" : "&");

      // iframe.src = url;
      // iframe.frameborder = "0";
      // iframe.width = "100%";
      // iframe.height = "100%";
      // document.getElementById("iframIndex").appendChild(iframe);
    },
    // 清空表单
    resetForm (formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields();
      }
    },

    closeDialog (){
      this.clearForm();
      this.$emit('reload');
      this.visible = false;
    },

    // 级联change事件，清空子项下拉选项和选中值
    clearForm(type) {
      this.optParams = {
        title : "",
        url : ""
      };
    },
    // 确认
    submitForm (formName) {
      // this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     this.demoLoading = true;
      //
      //     if(this.optParams.flag == "BXDCH"){
      //       //报销单撤回
      //       this.approveWithdrawCloud();
      //     }else if(this.optParams.flag == "BXDBH"){
      //       //报销单驳回
      //       this.manageApproveBackCloud();
      //     }
      //   }
      // });
    },
  }
}
</script>
